// Environment configuration
export const API_URL = import.meta.env.VITE_API_URL || 'https://solarium.girlindelfwn.gr/api';
